export default [
    {
        title: 'menu.monte.monte',
        icon: ['fal', 'venus-mars'],
        accessRights: 'SAILL',
        children: [
            // {
            //     title: 'menu.monte.tableau_bord',
            //     icon: ['fal', 'tachometer-slow'],
            //     to: { name: '' }
            // },
            // {
            //     title: 'menu.monte.depistages_vaccins',
            //     icon: ['fal', 'syringe'],
            //     to: { name: '' }
            // },
            {
                title: 'global.contracts_online',
                icon: ['fal', 'file-contract'],
                to: { name: 'ContractListOnline' },
                href: '#/monte/contrats_online/'
            },
            {
                title: 'menu.monte.planning_monte',
                icon: ['fal', 'alarm-clock'],
                to: { name: 'PlanningMonteBeta' },
                href: '#/planning_monte'
            },
			{
                title: 'menu.monte.gestion_expedition',
                icon: ['fad', 'truck-loading'],
                to: { name: 'monteReservation' },
                href: '#/monte/expeditions'
            },
            {
                title: 'menu.monte.suivi_dps',
                icon: ['fal', 'passport'],
                to: { name: 'carnet_saillie' },
                accessRights: 'DPS',
                href: '#/carnet_saillie'
            },
            {
                title: 'menu.monte.suivi_sanitaire',
                icon: ['fal', 'file-medical'],
                to: { name: 'sanitaire' },
                accessRights: 'SANI',
                href: '#/sanitaire'
			},
            {
                title: 'menu.monte.import_dn_as',
                icon: ['fal', 'download'],
                to: { name: 'import_dn_as' },
                accessRights: 'DPS',
                href: '#/import_dn_as'
            },
			{
				title: 'menu.monte.bilan',
				icon: ['fal', 'table'],
				to: { name: 'saisonMonte' },
                href: '#/bilans/monte'
			},
            {
                title: 'menu.monte.stock_semence_distant',
                icon: ['fal', 'crutch'],
                to: { name: 'stockDistant' },
                href: '#/monte/stock_distant',
                accessRights: 'SEMENCE'
            },
            {
                title: 'menu.monte.add_contract',
                icon: ['fal', 'crutch'],
                to: { name: 'CreateContract' }
            },
        ]
    },
    {

        title: 'menu.congelation.congelation',
        icon: ['fal', 'vials'],
        accessRights: 'CONGEL|FRAIS',
        children: [
            {
                title: 'menu.congelation.stocks',
                icon: ['fal', 'database'],
                to: { name: 'CongelationNotInventoried' },
                href: '#/congelation/stocks/not_inventoried',
                accessRights: 'CONGEL'
            },
            {
                title: 'monte.congelation.commandes',
                icon: ['fad', 'truck-loading'],
                to: { name: 'CongelationCommandeDemandes' },
                href: '#/congelation/commandes/demandes',
                accessRights: 'CONGEL|FRAIS'
            },
            {
                title: 'monte.congelation.expeditions',
                icon: ['fas', 'shipping-fast'],
                to: { name: 'CongelationExpeditionAttente' },
                href: '#/congelation/expeditions',
                accessRights: 'CONGEL|FRAIS'
            },
            {
                title: 'menu.congelation.production',
                icon: ['fal', 'chart-pie-alt'],
                to: { name: 'CongelationStatistiquesLot' },
                href: '#/congelation/production',
                accessRights: 'CONGEL|FRAIS'
            },
            {
                title: 'menu.congelation.facturation',
                icon: ['far', 'file-invoice'],
                to: { name: 'CongelationExpeditionLivresInvoice' },
                href: '#/congelation/facturation',
                accessRights: 'CONGEL|FRAIS'
            }
        ]
    }
]